import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiAward, FiBook } = FiIcons;

const ExpertsSection = () => {
  const experts = [
    {
      name: "Dr. Brian Llánez Araya",
      description: "Médico psiquiatra con más de 13 años de experiencia, formado en Mindfulness en Oxford. Creador del programa M.E.T.A.",
      icon: FiUser
    },
    {
      name: "Dr. Juan Carlos Alba Maldonado",
      description: "Médico y coach experto en salud integral con más de 15 años de experiencia. Fundador de Nutre tu Alma.",
      icon: FiAward
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-6xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">
            Liderado por Dos Mentes Brillantes
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {experts.map((expert, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl shadow-lg border border-blue-100"
              >
                <div className="flex items-center gap-4 mb-4">
                  <div className="bg-blue-600 p-3 rounded-full">
                    <SafeIcon icon={expert.icon} className="text-white text-2xl" />
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-800">
                    {expert.name}
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {expert.description}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ExpertsSection;